// extracted by mini-css-extract-plugin
module.exports = {"flagged":"ProposalTitle_flagged__oXpx4"};